module.exports = __webpack_public_path__ + "img/zxzf.aee77787.png";